<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>My Collections</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Collection
            </v-btn>
          </div>
        </div>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div v-show="isEdit">
          <div class="row">
            <div class="col">
              <v-text-field
                id="name"
                v-model="selectedObj.Name"
                :rules="nameRules"
                label="Collection Name*"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="description"
                v-model="selectedObj.Description"
                label="Collection Description"
              ></v-text-field>
            </div>
          </div>
          <div class="row" v-show="false">
            <div class="col">
              <v-text-field
                id="price"
                v-model="selectedObj.Price"
                label="Price"
                type="number"
              ></v-text-field>
            </div>
            <div class="col">
            </div>
          </div>
          <div class="row mt-5">
            <div class="col">
              <v-card>
                <div class="row" v-show="false">
                  <div class="col-5 ml-5">
                    <v-text-field
                      id="SearchPublication"
                      v-model="SearchPublication"
                      label="Search"
                    ></v-text-field>
                  </div>
                  <div class="col-6"></div>
                </div>
                <v-divider></v-divider>
                <div style="height: 350px; overflow-y: scroll">
                  <v-data-table
                    v-model="SelectedPublications"
                    :headers="collectionHeaders"
                    :items="AllPublications"
                    class="elevation-1"
                    item-key="Id"
                    hide-default-footer
                  >
                    <template v-slot:item.Id="{ item }">
                      <v-simple-checkbox
                        id="selected"
                        v-model="item.Selected"
                      ></v-simple-checkbox>
                    </template>
                  </v-data-table>
                </div>
                <v-row>
                  <v-col cols="12">
                    <Pagination
                      :paging="paging_collection"
                      v-on:next="onNextPageCollection"
                    />
                  </v-col>
                </v-row>
              </v-card>
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="float-right">
                <v-btn @click="onCancel()"> Cancel </v-btn>
                <v-btn
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-form>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left"></th>
                  <th style="width: 140px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Description }}</td>
                  <td></td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
    <PublicationCollections ref="publications" />
  </div>
</template>

<script>
import lodash from "lodash";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import PublicationCollections from "@/components/PublicationCollections";
import * as api from "@/api";

export default {
  name: "OrgMyCollections",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    PublicationCollections
  },
  props: {
    organization: { type: Object, required: true }
  },
  created() {
    this.getCollectionByPagin();
  },
  mounted() {},
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      try {
        if (this.SearchPublication) {
          return this.publications.filter(item => {
            return this.SearchPublication.toLowerCase()
              .split(" ")
              .every(v => item.Title.toLowerCase().includes(v));
          });
        } else {
          return this.publications;
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  methods: {
    onFilterData() {
      if (this.SearchPublication) {
        return this.publications.filter(p =>
          p.Title.includes(this.FilterPublication.toLowerCase())
        );
      } else return this.publications;
    },
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.selectedObj.Name = "";
      this.selectedObj.Description = "";
      this.selectedObj.publications = [];
      this.getPublicationByCollectionId(1);
      for (let i = 0; i < selectedObj.publications.length; i++) {
        this.selectedObj.publications[i].IsSelected = false;
      }
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getCollectionByPagin();
    },
    onPopup(item) {
      this.$refs.publications.open("Publications", item.id);
    },
    onSave() {
      this.notify.type = 0;
      this.notify.errors = [];
      this.selectedObj.organization = this.organization;
      this.selectedObj.PerentCollectionId = this.PerentCollectionId;

      let selectedPublications = lodash.filter(this.AllPublications, {'Selected': true});

      let selectedPublicationIds = lodash.map(
        selectedPublications,
        function(pub) {
          return { id: pub.Id };
        }
      );
      console.log("Selected Publications");
      console.log(selectedPublicationIds);
      this.selectedObj.publications = selectedPublicationIds;

      console.log(this.selectedObj);
      this.$refs.form.validate();

      if (!this.valid) return;

      if (this.selectedObj.publications.length == 0) {
        this.notify.type = 4;
        this.notify.errors.push("Please add publications.");
        return;
      }
      this.loading = true;
      new Promise((resolve, reject) => {
        api
          .update("organization-collection", this.selectedObj)
          .then(response => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
              this.getCollectionByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
          })
          .catch(error => {
            this.notify.type = 4;
            this.notify.errors.push("Failed to save data. " + error);
            this.loading = false;
            reject(error);
          });
      });
    },
    onEdit(obj) {
      this.isEdit = true;
      this.SearchPublication = "";
      this.selectedObj = Object.assign({}, obj);
      this.PerentCollectionId = this.selectedObj.PerentCollectionId;
      this.getPublicationByCollectionId(obj.id);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization-collection", obj.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getCollectionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
    },
    getCollections() {
      that = this;
      new Promise((resolve, reject) => {
        api
          .getAll("collection")
          .then(response => {
            console.log(response);
            that.list = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.this.getCollectionByPagin();
    },
    getCollectionByPagin() {
      let that = this;
      that.list.splice(0, that.list.length);
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization-collection", this.paging)
          .then(response => {
            console.log(response);
            this.paging.count = response.data.count;
            response.data.data.forEach(e => {
              that.list.push(e);
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUserCollections() {
      new Promise((resolve, reject) => {
        api
          //.getAll("licenses/user-collection/1")  ///api/v1/licenses/opds/collection/{id}
          .getByID("licenses/opds/collection", 1)
          .then(response => {
            console.log(" opds " + response);
          })
          .catch(error => {
            console.log(" opds " + error);
            reject(error);
          });
      });
    },
    getPublication() {
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getByID(
            "publication-collection/organization",
            localStorage.organizationId
          )
          .then(response => {
            console.log(response);
            this.publications = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getPublicationByCollectionId(id) {
      new Promise((resolve, reject) => {
        let that = this;
        api
          .getByPaginById(
            `organization-collection/publication`,
            id,
            this.paging_collection
          )
          .then(response => {
            that.publications.splice(0, that.publications.length);
            if (response.data.data != null && response.data.data.length > 0) {
              for (let i = 0; i < response.data.data.length; i++) {
                that.AllPublications.push({
                  Selected: response.data.data[i].IsSelected,
                  Id: response.data.data[i].id,
                  Title: response.data.data[i].Title,
                  ISBN: response.data.data[i].ISBN,
                  PublisherName: response.data.data[i].PublisherName
                });
              }
              this.paging_collection.count = response.data.count;
            }

            console.log(that.publications);
            that.SearchPublication = " ";
            that.SearchPublication = "";
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onNextPageCollection() {
      this.paging_collection.page = page;
      this.getPublicationByCollectionId(selectObj.id);
    }
  },
  data() {
    return {
      list: [],
      publications: [],
      isEdit: false,
      isNew: false,
      Search: "",
      SearchPublication: "",
      FilterPublication: "",
      AllPublications: [],
      SelectedPublications: [],
      searchUser: null,
      selectedObj: {},
      selectedCollection: [],
      paging_collection: { count: 10, page: 1, size: 10, keyword: "" },
      notify: {
        type: 0,
        message: "",
        errors: []
      },
      valid: true,
      nameRules: [v => !!v || "Collection name is required"],
      loading: false,
      paging: {
        count: 0,
        page: 1,
        size: 10,
        keyword: "",
        orderColumn: "",
        isASC: true,
        skip: null
      },
      priceRules: [v => !!v || "Price is required"],
      seatRules: [v => !!v || "Seat is required"],
      collectionHeaders: [
      {
          text: "",
          align: "start",
          sortable: false,
          value: "Id"
        },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "Title"
        },
        {
          text: "ISBN",
          align: "start",
          sortable: false,
          value: "ISBN"
        },
        {
          text: "PublisherName",
          align: "start",
          sortable: false,
          value: "PublisherName"
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/organization/OrgMyCollections.vue